var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print_black_24dp_3_",
    "data-name": "print_black_24dp (3)",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56175",
    "data-name": "Path 56175",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56176",
    "data-name": "Path 56176",
    d: "M19,8H5a3,3,0,0,0-3,3v4a2.006,2.006,0,0,0,2,2H6v2a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V17h2a2.006,2.006,0,0,0,2-2V11A3,3,0,0,0,19,8ZM15,19H9a1,1,0,0,1-1-1V14h8v4A1,1,0,0,1,15,19Zm4-7a1,1,0,1,1,1-1A1,1,0,0,1,19,12ZM17,3H7A1,1,0,0,0,6,4V6A1,1,0,0,0,7,7H17a1,1,0,0,0,1-1V4A1,1,0,0,0,17,3Z",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a33764153bd22628a2c2a139aad68d47.svg";
export { ForwardRef as ReactComponent };